import { inject } from '@angular/core'
import { EMPTY, filter, of, switchMap } from 'rxjs'
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router'
import { MsalBroadcastService, MsalService  } from '@azure/msal-angular'
import { InteractionStatus, RedirectRequest } from '@azure/msal-browser'
import { AuthService } from '@appShared/services/auth.service'
import { SITE_DIRECTORY_ROUTES } from '@appShared/site-directory.routes'

//https://blog.mastykarz.nl/redirect-custom-login-page-securing-angular-app-msal/
export const CanActivateGuardService: CanActivateFn = (
   route: ActivatedRouteSnapshot,
   state: RouterStateSnapshot
) => {
   //TODO remove
   //return of(true)

   const authService = inject(AuthService)
   const msalService = inject(MsalService)
   const msalBroadcastService = inject(MsalBroadcastService)
   const router = inject(Router)

   return msalBroadcastService.inProgress$
      .pipe(
         filter((status: InteractionStatus) => status === InteractionStatus.None),
         switchMap(() => {
            if (msalService.instance.getAllAccounts().length > 0) {
               return of(true)
            }

            authService.redirectUrl.set(state.url)
            router.navigate([`/`])
            return of(false)
         })
      )
}
